module.exports = __webpack_public_path__ + "img/DE00457.702a1342.png";